






import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class ModalTextLink extends Vue {
  @Prop() name!: string;

  show() {
    if (window.innerWidth >= 480) {
      this.$modal.show(`${this.name}_pc`);
    } else {
      this.$modal.show(`${this.name}_sp`);
    }
  }
}
